import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { configureStore } from "./redux/Store";
import Spinner from "./views/spinner/Spinner";
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import "./assets/scss/style.scss";

// setup fake backend
import { ConfigureFakeBackend } from "./jwt/_helpers";
ConfigureFakeBackend();
const App = lazy(
  () =>
    new Promise((resolve) => {
      setTimeout(() => resolve(import("./app")), 0);
    })
);

ReactDOM.render(
  <Suspense fallback={<Spinner />}>
    <Provider store={configureStore()}>
      <App />
    </Provider>
  </Suspense>,
  document.getElementById("root")
);
